
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSnowShowersDay as ObiLightningLightSnowShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-snow-showers-day.js';
 
 
 

 
 export const ObiLightningLightSnowShowersDay = createComponent({
   react: React,
   tagName: 'obi-lightning-light-snow-showers-day',
   elementClass: ObiLightningLightSnowShowersDayElement,
   events: {
     
   }
  });
 
 